import PropTypes from 'prop-types';
import { cn } from 'Utils/cn';

export default function IconCompleted(props) {
    const { isCompleted, className } = props;

    return (
        <div
            className={cn(
                'inline-flex items-center justify-center shrink-0',
                'bg-white size-7 rounded-full border border-gray-200 transition-all',
                isCompleted && 'bg-success border-success text-white',
                className,
            )}
        >
            {isCompleted && (
                <svg stroke="currentcolor" width="15" height="15" fill="none" viewBox="0 0 12 12">
                    <path strokeLinecap="round" strokeWidth="1.75" d="M2 6l2.894 2.894a.15.15 0 00.212 0L11 3"></path>
                </svg>
            )}
        </div>
    );
}

IconCompleted.propTypes = {
    isCompleted: PropTypes.bool,
    className: PropTypes.string,
};
